import dynamic from 'next/dynamic';
import { ComponentType } from 'react';
import { CommonBannerProps } from '../AllTherapists/components/banners/BannerBase';
import { TherapistSearchRequestDtoReligionsEnum } from '@app/api';

const OrthodoxyBanner = dynamic(
  import('../AllTherapists/components/banners/OrthodoxyBanner'),
);
const IslamismBanner = dynamic(
  import('../AllTherapists/components/banners/IslamismBanner'),
);

interface ReligionBannerLink {
  id: string; // I'm not sure why it's hardcoded, i think we can get these options from backend
  Component: ComponentType<CommonBannerProps>;
}

export const linkedReligionBanners: ReligionBannerLink[] = [
  {
    id: TherapistSearchRequestDtoReligionsEnum.Christianity,
    Component: OrthodoxyBanner,
  },
  {
    id: TherapistSearchRequestDtoReligionsEnum.Islamism,
    Component: IslamismBanner,
  },
];
